import axios from 'axios';
import Cookies from "js-cookie";

const token = Cookies.get('noohraToken')
const apiUrl = "https://noohraserver.onrender.com/api/v1/"; // Replace with your actual endpoint

export const createUser = async (payload) => {
    try {
        // Define the API endpoint

        // Send the POST request with the payload
        const response = await axios.post(apiUrl + 'auth/signup', payload, {
            headers: {
                "Content-Type": "application/json", // Set the content type
            },
        });

        // Log and return the response
        return response.data;
    } catch (error) {
        console.error("Error creating user:", error);
        throw error;
    }
};

export const loginUser = async (payload) => {
    try {
        // Send the POST request with the payload
        const response = await axios.post(apiUrl + 'auth/login', payload, {
            headers: {
                "Content-Type": "application/json", // Set the content type
            },
        });

        // Log and return the response
        const { token } = response.data?.data;
        Cookies.set('noohraToken', token)

        return response.data;
    } catch (error) {
        console.error("Error logging in user:", error);
        throw error;
    }
};

export const getBookings = async () => {
    try {
        // Send the POST request with the payload
        const response = await axios.get(apiUrl + 'booking', {
            headers: {
                "Content-Type": "application/json", // Set the content type
                "Authorization": `Bearer ${token}` // Add the authorization token
            },
        });

        // Log and return the response
        return response.data;
    } catch (error) {
        console.error("Error fetching bookings:", error);
        throw error;
    }
};

export const postImage = async (imageFiles) => {
    try {
        const formData = new FormData();

        // Loop through multiple files and append them
        imageFiles.forEach((file) => formData.append("images", file));

        const response = await axios.post(`${apiUrl}gallery`, formData, {
            headers: {
                "Content-Type": "multipart/form-data", // Required for file uploads
                "Authorization": `Bearer ${token}`, // Attach auth token
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error uploading image:", error);
        throw error;
    }
};

export const deleteImage = async (id) => {
    try {

        // Loop through multiple files and append them
        const response = await axios.delete(`${apiUrl}gallery/${id}`, {
            headers: {
                "Content-Type": "multipart/form-data", // Required for file uploads
                "Authorization": `Bearer ${token}`, // Attach auth token
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error uploading image:", error);
        throw error;
    }
};

export const getGallery = async () => {
    try {

        // Send the POST request with the payload
        const response = await axios.get(apiUrl + 'gallery', {
            headers: {
                "Content-Type": "application/json", // Set the content type
            },
        });

        // Log and return the response
        return response.data;
    } catch (error) {
        console.error("Error fetching bookings:", error);
        throw error;
    }
};


export const getUser = async () => {
    try {

        // Send the POST request with the payload
        const response = await axios.get(apiUrl + 'auth/me', {
            headers: {
                "Content-Type": "application/json", // Set the content type
                "Authorization": `Bearer ${token}` // Add the authorization token
            },
        });

        // Log and return the response
        return response.data;
    } catch (error) {
        console.error("Error fetching user:", error);
        throw error;
    }
};

export const getAllUsers = async () => {
    try {

        // Send the POST request with the payload
        const response = await axios.get(apiUrl + 'auth/userList', {
            headers: {
                "Content-Type": "application/json", // Set the content type
                "Authorization": `Bearer ${token}` // Add the authorization token
            },
        });

        // Log and return the response
        return response.data;
    } catch (error) {
        console.error("Error fetching users:", error);
        throw error;
    }
};

export const getServices = async (type, location) => {
    try {
        // Construct the query string dynamically
        let queryParams = [];
        if (type) queryParams.push(`type=${encodeURIComponent(type)}`);
        if (location) queryParams.push(`location=${encodeURIComponent(location)}`);

        const queryString = queryParams.length ? `?${queryParams.join('&')}` : '';

        // Send the POST request with the payload
        const response = await axios.get(`${apiUrl}services${queryString}`, {}, {
            headers: {
                "Content-Type": "application/json", // Set the content type
            },
        });

        // Log and return the response
        return response.data;
    } catch (error) {
        console.error("Error fetching user:", error);
        throw error;
    }
};


export const editService = async (id, payload) => {
    try {
        // Send the POST request with the payload
        const response = await axios.patch(apiUrl + `services/${id}`, payload, {
            headers: {
                "Content-Type": "application/json", // Set the content type
                "Authorization": `Bearer ${token}` // Add the authorization token
            },
        });

        // Log and return the response
        return response.data;
    } catch (error) {
        console.error("Error updating service:", error);
        throw error;
    }
};

export const createBooking = async (payload) => {
    try {
        // Send the POST request with the payload
        const response = await axios.post(apiUrl + 'booking', payload, {
            headers: {
                "Content-Type": "application/json", // Set the content type
            },
        });

        // Log and return the response
        return response.data;
    } catch (error) {
        console.error("Error sending booking:", error);
        throw error;
    }
};